import { Grid } from "@mui/material";
import { useReward } from "api/rewards";
import { EffectSearch } from "components/EffectSearch/EffectSearch";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { useFormikContext } from "formik";
import { useMessage } from "hooks/intl";
import { useManageInfiniteScroll } from "hooks/useManageInfiniteScroll";
import _ from "lodash";
import { useState } from "react";
import { CampaignFEValues } from "types/campaigns";
import { templates } from "./data";

export function GiveReward({ fieldName }: { fieldName: string }) {
  const { message } = useMessage();
  const { values, setFieldValue } = useFormikContext<CampaignFEValues>();
  const { useRewardData, useInfiniteRewardList } = useReward();
  const rewardId = _.get(values, `${fieldName}.rewardId`);
  const { data: rewardData } = useRewardData(rewardId || "");
  const [rewardSearch, setRewardSearch] = useState("");

  const {
    data: infiniteRewardList,
    size: rewardListSize,
    setSize: setRewardListSize,
    isValidating,
  } = useInfiniteRewardList({
    filters: rewardSearch
      ? [
          {
            condition: "like",
            query: "name",
            value: rewardSearch,
          },
          {
            query: "active",
            condition: "eq",
            value: true,
          },
        ]
      : [
          {
            query: "active",
            condition: "eq",
            value: true,
          },
        ],
    order: "asc",
    sortKey: "name",
  });

  const { infiniteData: rewardsList, anyElementsToFetch: anyRewardsToFetch } =
    useManageInfiniteScroll(infiniteRewardList || []);

  const filteredRewardList = rewardsList.filter(
    (item) => item.reward !== "conversion_coupon",
  );

  const showRewardRuleInput =
    rewardData && rewardData.reward === "dynamic_coupon";

  return (
    <>
      <Grid item xs={6}>
        <SelectInput
          displaySearch
          name={`${fieldName}.rewardId`}
          items={
            filteredRewardList
              ? filteredRewardList.map((reward) => ({
                  id: reward.rewardId,
                  label: reward.name,
                }))
              : []
          }
          label={<RequiredFieldLabel text={message({ id: "reward" })} />}
          placeholder={message({ id: "findByRewardName" })}
          data-test-id="effect-reward-type"
          asyncSearch={(val: string) => setRewardSearch(val)}
          initialValue={
            rewardData && {
              id: rewardData.rewardId,
              label: rewardData.name,
            }
          }
          onChange={(_: any, rewardId: string) => {
            const rewardDetails = filteredRewardList.find(
              (reward) => reward.rewardId === rewardId,
            );

            if (rewardDetails?.reward !== "dynamic_coupon") {
              setFieldValue(`${fieldName}.couponValueRule`, undefined);
            }
          }}
          anyElementsToFetch={anyRewardsToFetch}
          loadMoreElements={() =>
            !isValidating && setRewardListSize(rewardListSize + 1)
          }
        />
      </Grid>
      {showRewardRuleInput && (
        <Grid item xs={12}>
          <EffectSearch
            data-test-id="give-reward"
            items={templates}
            name={`${fieldName}.couponValueRule`}
            placeholder={message({ id: "chooseTemplatesFromTheList" })}
          />
        </Grid>
      )}
    </>
  );
}
